import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why" },
  { label: "Network", href: "#network" },
  { label: "Locations", href: "#locations" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_ad-network-hub-3/artifacts/likzaj1c_Picture1.png"
            alt="Green Signs"
            className="h-16 md:h-20 w-auto object-contain"
            style={{ imageRendering: "auto" }}
            data-testid="brand-logo-image"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => handleNav(l.href)}
              className="relative text-sm tracking-[0.2em] uppercase text-forest-600 hover:text-forest-900 transition-colors duration-300 group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-brass transition-all duration-500 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta-explore"
          onClick={() => handleNav("#contact")}
          className="hidden md:inline-flex btn-ghost !py-2.5 !px-5 text-xs"
        >
          Explore
        </button>

        <button
          aria-label="Toggle navigation"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-forest-800"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden glass-nav border-t border-forest-800/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                onClick={() => handleNav(l.href)}
                className="text-left text-sm tracking-[0.2em] uppercase text-forest-600 hover:text-brass transition"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("#contact")}
              className="btn-gold mt-2"
              data-testid="mobile-nav-cta"
            >
              Explore Opportunities
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
